import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

import { IosInstallCodeDto } from '@/dtos/codes/codes.dto';
import { IosInstallCode } from '@/models/codes/codes.model';

export const mapIosInstallCode: MapFromFn<IosInstallCodeDto, IosInstallCode> = (value) =>
  Builder.forModel(IosInstallCode).url(value.url).store(value.store).build();
